import React from "react";

const SafeDynamicComponent = ({ Component, fallback = null, ...props }) => {
    if (!Component) {
        console.warn("Tried to render undefined component. Props:", props);
        return fallback ?? <div>Unknown Component</div>;
    }
    return <Component {...props} />;
};

export default SafeDynamicComponent;